import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconPasteStyle0 = gravityIconIndividualCss;

const GravityIconPaste = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '3ab6d4f65637eec53ef57b1be991e378859ab8f0', color: this.color, size: this.size }, h("svg", { key: 'cad2b6dfd60840339552db77b18296c06038aece', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '428eb6fc9203dd53023f96e3f25e7d7aa4c72f57', d: "M10.5 3.5A.5.5 0 0 1 11 3h3a.5.5 0 0 1 .5.5V4H17a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5V15a.5.5 0 0 1 .5-.5h1v-9H9v1a.5.5 0 0 1-.5.5H8a.5.5 0 0 1-.5-.5v-2A.5.5 0 0 1 8 4h2.5v-.5Z", fill: "currentColor" }), h("path", { key: 'b6f0b4d524ee8241ff49eb4bbbf35aa9c471381e', d: "M4.5 8.5A.5.5 0 0 1 5 8h8a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5v-10Z", fill: "currentColor" }))));
    }
};
GravityIconPaste.style = GravityIconPasteStyle0;

export { GravityIconPaste as gravity_icon_paste };

//# sourceMappingURL=gravity-icon-paste.entry.js.map